import { fromJS } from 'immutable'

export const studentState = fromJS({
  id: 0,
  username: '',
  email: '',
  last_name: '',
  first_name: '',
  middle_name: '',
  suffix_name: '',
  full_name1: '',
  sex: '',
  dob: '',
  photo: '',
  civil_status: '',
  address: '',
  zip: '',
  citizenship: '',
  pob: '',
  religion: '',
  meta: {
    height: '',
    weight: '',
    contact1: '',
    intermediate_name: '',
    intermediate_address: '',
    intermediate_sy: '',
    secondary_name: '',
    secondary_address: '',
    secondary_sy: '',
  },
})

const initialState = fromJS({
  searchResults: [],
  pending: false,
  searching: false,
})

export default function student(state = initialState, action) {
  switch (action.type) {
    case 'STUD_REQ':
      return state.set('pending', true)

    case 'STUD_Q_REQ':
      return state.set('searching', true)

    case 'STUD_Q_SUCC':
      return state
        .set('searching', false)
        .set('searchResults', fromJS(action.payload || []))

    case 'STUD_GET_SUCC':
    case 'STUD_SAVE_SUCC':
    case 'NOTIF_FAIL':
      return state
        .set('pending', false)
        .set('searching', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Students/reducer.js